import axios from 'axios';

import {
    MARKET_QUERY_URL,
    MARKET_SL_QUERY_URL,
} from './url';

import { SET_CURRENT_MARKETING, SET_MARKETING_ALL, RESET_MARKETING, SET_MARKETING_PRODUCT_LIST } from './type';


function setMarketingAll(data) {
    return {
      type: SET_MARKETING_ALL,
      payload: data,
    };
}
function setMarketingProductList(data) {
    return {
      type: SET_MARKETING_PRODUCT_LIST,
      payload: data,
    };
}

export function reSetMarketing() {
    return {
      type: RESET_MARKETING,
    };
}
export function setCurrentMarketing(data) {
    return {
      type: SET_CURRENT_MARKETING,
      payload: data,
    };
}

export function fetchMarketInfo() {// 请求全部的marketing
    return (dispatch) => {
    //   dispatch(fetchingBillboardImages());
      const token = localStorage.getItem('token');
      return axios({
        method: 'get',
        url: MARKET_QUERY_URL,
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => {
          dispatch(setMarketingAll(response));
        }, (err) => {
          if(err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          }            
        //   dispatch(fetchBillboardImagesFailure(err));
        });
    };
}

export function fetchMarketProduct(id) {// 根据marketing查询商品
    return (dispatch) => {
    //   dispatch(fetchingBillboardImages());
      const token = localStorage.getItem('token');
      let url = MARKET_SL_QUERY_URL;
      if(id != -1) {
        url = url + `?marketing=${id}`;
      }
      return axios({
        method: 'get',
        url,
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => {
          dispatch(setMarketingProductList(response));
        }, (err) => {
          if(err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          }
        });
    };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/market_action.js